import { ReactNode } from 'react';

interface PageTransitionContainerProps {
  children: ReactNode;
  isVisible: boolean;
  className?: string;
}

export const PageTransitionContainer: React.FC<PageTransitionContainerProps> = ({ children, isVisible, className = '' }) => {
  return <div className={`transform transition-all duration-500 ease-out ${isVisible ? 'translate-x-0 opacity-100' : 'translate-x-full opacity-0'} ${className}`}>{children}</div>;
};

interface PageTransitionButtonContainerProps {
  children: ReactNode;
  isVisible: boolean;
  className?: string;
}

export const PageTransitionButtonContainer: React.FC<PageTransitionButtonContainerProps> = ({ children, isVisible, className = '' }) => {
  return (
    <div
      className={`fixed bottom-0 left-0 right-0 transform p-6 transition-all duration-500 ease-out ${
        isVisible ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'
      } ${className}`}
    >
      {children}
    </div>
  );
};
